var React = require('react');

function Card (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M34.8962 -0.0078125H7.10418C3.67218 -0.0078125 0.888184 2.77619 0.888184 6.20819V25.7922C0.888184 29.2242 3.67218 32.0082 7.10418 32.0082H34.8962C38.3282 32.0082 41.1122 29.2242 41.1122 25.7922V6.20819C41.1122 2.77619 38.3282 -0.0078125 34.8962 -0.0078125ZM37.5122 25.7922C37.5122 27.2322 36.3362 28.4082 34.8962 28.4082H7.10418C5.66418 28.4082 4.48818 27.2322 4.48818 25.7922V6.20819C4.48818 4.76819 5.66418 3.59219 7.10418 3.59219H34.8962C36.3362 3.59219 37.5122 4.76819 37.5122 6.20819V25.7922ZM8.95218 8.17619H14.9522V11.6802H8.95218V8.17619Z","fill":"#4C4C4C"}));
}

Card.defaultProps = {"width":"42","height":"32","viewBox":"0 0 42 32","fill":"none","className":"icon"};

module.exports = Card;

Card.default = Card;
